// extracted by mini-css-extract-plugin
export var alertIcon = "_rn-0";